import axios from 'axios';

const ASTROLOGY_API_URL = `https://json.astrologyapi.com/v1/zodiac_compatibility`;
const USER_ID = `613295`;
const API_KEY = `f7e2c8bf0e86387edfbb54c843460749`;

export const start = () => {
  return {
    type: `GET_COMPATIBILITY_REPORT_START`,
  };
};

export const success = (data) => {
  return {
    type: `GET_COMPATIBILITY_REPORT_SUCCESS`,
    data,
  };
};

export const failure = () => {
  return {
    type: `GET_COMPATIBILITY_REPORT_FAILURE`,
  };
};


const getCompatibility = (yourSign, partnerSign) => async (dispatch) => {
  const url = `${ASTROLOGY_API_URL}/${yourSign}/${partnerSign}`;

  dispatch(start());
  try {
    const response = await axios({
      method: `post`,
      url,
      headers: {
        Authorization: `Basic ${btoa(`${USER_ID}:${API_KEY}`)}`,
        "Content-Type": `application/json`,
      },
    });
    if (response.data) {
      dispatch(success(response.data));
      return;
    }
  } catch (e) {
    dispatch(failure());
    throw new Error(`There was an error processing your compatibility report! Try again later.`);
  }
};

export default getCompatibility;
